import {isIEBrowser} from '@/utils'
import {CertInfo,CAEnums,loacCaServer} from '../cainfo'

var keyApi;
var userCA;
var Ahca = function () {
    this.caname =CAEnums.ahca;
    this.random="";
    this.caInfo=new CertInfo();
};
Ahca.prototype = {
    getPluginObjcet(objName) {
        return document.getElementById(objName);
    },
    initOcxPlugin(callback) {
        keyApi = this.getPluginObjcet('CAx')
        let initialize = keyApi.ESSInitClientCert()
        if (!initialize) {
            this.caInfo.userCa = false
        }
        let that = this
        loacCaServer('AH',function (data) {
            if (data && data.code === "1") {
                that.random=data.data.random
            }else{
                alert(data.msg);
            }
        })
        callback && callback(this.caInfo.userCa)
    },
    /**
     * 加载当前环境所有CA列表
     * @returns {boolean}
     */
    getCaKeyInfo(callback) {
        this.caInfo = new CertInfo();
        keyApi.AddLicense('3LKzp8gknhTBrYi1xoUCHJs3rdbeMSjTabufvyVSkis5s/47y9PRwnoy923L09tYjUhxtrGxXLDV1lAGAP5t7r/LlRKM3xe39elUfaQOkJrpwBYB5ZK4aWKS7bgkuKGXIP7v+XxFp9rIWv8JothGtVr7J1JUUX4tBHj6pyYLGZhI7CTszRbhDgZla7kdKPXghzCfbK8ZdKHCr1UFrBsDTaVkzTxphd6CIbJ2FFA6Z/rBiziXIFc3VeV2chunEQVt73XgjKzqdCKTUW/5CahoOQ==');
        keyApi.GetCAModule('http://218.94.148.222:8080/calist/CaList');
        this.caInfo.certserial = keyApi.ESSClientSignCertSN()
        this.caInfo.certName = keyApi.ESSClientSignCertCN()
        this.caInfo.random = this.random
        this.caInfo.base64cert = keyApi.ESSSignCert()
        // this.caInfo.validendtime = keyApi.ESSCertYouXiaoQi()
        this.caInfo.validendtime = keyApi.ESSGetCertDeadline()
        callback && callback(this.caInfo)
    },
    /**
     * 验证密码并生成签名
     * @param inData
     * @param keyPin
     * @param successCallback
     * @returns {string|boolean|*}
     */
    getSignData() {
        let signData = {
            certsigndata : keyApi.ESSSignDataEx(this.caInfo.random, this.caInfo.base64cert, 0, 1),
            random : this.random
        }
        return signData
    },
};


export default Ahca
